import { atom } from 'jotai';
import ZendeskChatService from './zendeskChatService';

export const zendeskChatServiceAtom = atom<ZendeskChatService>(() => new ZendeskChatService());
